var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c(_setup.FlagMenu,{attrs:{"disabled":_setup.compDisabled,"model":_vm.model},on:{"input":(v)=>_setup.setValue(v)},model:{value:(_vm.model.flag),callback:function ($$v) {_vm.$set(_vm.model, "flag", $$v)},expression:"model.flag"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }